import React, { useEffect, useState } from 'react';
import InstructionGeneratorAdd from './InstructionGeneratorAdd';
import OKNOKDropField from './OKNOKDropField/OKNOKDropField';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import BottomBar from '../../components/common/Instruction/BottomBar/BottomBar';
import {
  getInstructionData,
  orderDataOfficialNameChanged,
  orderDataProblemDescriptionChanged, orderDataVersionMetadataMessageChanged,
  orderIdChanged,
  saveInstructionData
} from '../actions/instuctionActions';
import { connect } from 'react-redux';
import StyledFormControl from '../../components/common/StyledFormControl';
import VersionMessageModalContainer from '../../components/common/containers/modals/VersionMessageModalContainer';
import VersionsListContainer from './../../components/common/containers/VersionsListContainer';
import { encodeParams } from '../../utils';
import InstructionGeneratorStaticFields from './InstructionGeneratorStaticFields';
import InstructionGeneratorHybridFields from './InstructionGeneratorHybridFields';
import Point from './Point';
import SectionManagement from './SectionManagement';
import AddComponentSection from './AddComponentSection';
import MatSpinner from '../../components/common/Mat/MatSpinner';

function InstructionGeneratorPage (props) {
  const [showVersionModal, setShowVersionModal] = useState(false);
  const [dataIndex, setDataIndex] = useState(0);
  const [disable, setDisable] = useState(false);
  const showVersionModalStatus = () => { setShowVersionModal(true); };
  const hideVersionModalStatus = () => { setShowVersionModal(false);};

  const findIndexById = (id) => {
    //powiązać ID z indexem z versions @todo!!!
    if (!id) {
      setDataIndex(props.versions.length-1);
      return;
    }
    const index = props.versions.findIndex(data=> data._id === id);
    setDataIndex(index);
  }

  useEffect(() => {

    props.dispatch(orderIdChanged(props.match.params.orderId));
    props.dispatch(getInstructionData(props.match.params.orderId));

  }, []);

  useEffect(() => {
    if(props.versions) {
      findIndexById(props.match.params.versionId);
      setDisable(!!props.match.params.versionId || props.instructionLoading);
    }
  }, [props.versions, props.match.params.versionId, props.instructionLoading]);

  const updateVersionMetadataMessage = (value) => { props.dispatch(orderDataVersionMetadataMessageChanged(value)); };

  const saveInstruction = () => {
    props.dispatch(saveInstructionData());
    setShowVersionModal(false);
  };

  return (
    <div>
      {/*{props.instructionLoading && (*/}
      {/*  <div style={{ width: '100%', height: '100%', position: 'fixed', zIndex: 10000, backgroundColor: "rgba(0,0,0,0.4)", padding: "22%", top: 0, bottom: 0, left: 0, right: 0}}>*/}
      {/*    <MatSpinner />*/}
      {/*  </div>*/}
      {/*)}*/}
      <InstructionGeneratorStaticFields />
      <InstructionGeneratorHybridFields />
      <SectionManagement dataIndex={dataIndex} disable={disable} />
      <AddComponentSection versionIndex={dataIndex} disable={disable} />
      {props.instructionLoading && (<BottomBar isLoading={true}/>)}
      {!props.instructionLoading && (props.instructionWasEdited || props.requiredCreateNewOrderVersion) && (<BottomBar doSave={showVersionModalStatus}
                 buttonText={props.requiredCreateNewOrderVersion ? 'Save & Update Order' : 'Save'} error={props.saveError}
      />)}
      <VersionMessageModalContainer
        show={showVersionModal}
        helpText="All modifications to this instruction are tracked. Please summarize all changes, this message will be saved along with your username and all changed fields."
        onClosed={hideVersionModalStatus}
        onSaved={saveInstruction}
        modalVersionMessage={props.versionMetadataMessage}
        onModalVersionMessageChanged={(ev) => updateVersionMetadataMessage(ev.target.value)}
      />
    </div>
  );
}

function mapStateToProps ({ instructionsReducer }) {
  return {
    ...instructionsReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructionGeneratorPage);
